function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#348C30;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M315.5,325.6c-3.6,3.6-8.4,5.5-13.3,5.5c-2.4,0-4.8-0.5-7.2-1.4c-7-2.9-11.6-9.7-11.6-17.3V272l-12.1,12.1 c-3.5,3.5-8.3,5.5-13.3,5.5h-42.2c-10.4,0-18.8-8.4-18.8-18.8s8.4-18.8,18.8-18.8h34.5l38.6-38.6c5.4-5.4,13.4-7,20.4-4.1 s11.6,9.7,11.6,17.3V267l84.5-84.5c-1.4-1.6-2.7-3.2-4.2-4.7c-32.5-32.5-85.2-32.5-117.7,0l0,0c-32.5-32.5-85.2-32.5-117.7,0 s-32.5,85.2,0,117.7l117.7,117.7l117.7-117.7c21.1-21.1,28.4-50.8,22.1-77.9L315.5,325.6z"
});

var SvgOxySocial = function SvgOxySocial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOxySocial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oxy-social.c4cbbee8.svg";
export { ForwardRef as ReactComponent };